// The patient pages switch (showcase look, 15 Oct): the patient Overview hub, the one-page chart with its
// sticky index and the visit cards. Same pattern as `encounter-flags.ts`:
//   ?x=patient-pages    turn the switch on (remembered in this browser)
//   ?x=-patient-pages   turn it off again
// OFF by default. With the switch OFF every patient screen renders exactly as it did before this file existed.
// Storage can be missing or blocked, so every read and write is guarded and a failure reads as OFF.
import { useState } from 'react';

export const PATIENT_PAGES_PARAM = 'x';
export const PATIENT_PAGES_NAME = 'patient-pages';
const STORAGE_KEY = 'scrips.patientPages';

function readStored(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'on';
  } catch {
    return false;
  }
}

function writeStored(on: boolean): void {
  try {
    if (on) window.localStorage.setItem(STORAGE_KEY, 'on');
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage unavailable: the switch stays as it was (OFF unless already stored).
  }
}

/** Applies any `x` query parameters to the stored switch. Unknown names are ignored. */
export function applyPatientPagesParams(search: string): void {
  const requested = new URLSearchParams(search).getAll(PATIENT_PAGES_PARAM);
  for (const entry of requested) {
    if (entry === PATIENT_PAGES_NAME) writeStored(true);
    else if (entry === `-${PATIENT_PAGES_NAME}`) writeStored(false);
  }
}

/** True only when this browser has turned the switch on. */
export function isPatientPagesOn(): boolean {
  if (typeof window === 'undefined') return false;
  applyPatientPagesParams(window.location.search);
  return readStored();
}

/** Read once per mount, so a screen never flips look half-way through a render tree. */
export function usePatientPages(): boolean {
  const [on] = useState(() => isPatientPagesOn());
  return on;
}
